import React from "react";
import "./Banner.scss";
import { Link } from "react-router-dom";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { handleScroll, whatsAppBotListener } from "../../utils/Utils";
import { CONTACTUS_SECTION_ID, PHONE_NUMBER } from "../../utils/Constant";
import clinicIcon from '../../assets/ivory/DenviaLogo.png';

const Banner = () => {
    return (
        <section
            id="banner-section"
            className="section-bg home-bg banner-section"
        >
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container banner-text-div">
                        <div className="row">
                            <div className="col-lg-6 heading-text-div">
                                <div
                                    className="banner-text"
                                    data-aos="fade-up"
                                    data-aos-duration="1000"
                                >
                                    <h1 className="banner-para">Your Path to a Healthy Dental Life.</h1>
                                    <p className="para-trust">
                                        {/* <span className="clinic-name-text">
                                            Ivory Multispeciality Dental Clinic
                                        </span> */}
                                        <span className="clinicName">Denvia Multispeciality Dental Clinic</span>,is a modern and patient-focused dental clinic located in Shyam Nagar, Jaipur, dedicated to providing high-quality dental care with advanced technology and personalized treatment plans. Our clinic offers a wide range of dental services, from routine dental check-ups and preventive care to advanced procedures such as dental implants, smile makeovers, crowns, bridges, dentures, and full mouth rehabilitation. Our expert team ensures your smile stays bright and healthy.
                                         Experience personalised care in a comfortable environment designed for your well being.
                                    </p>

                                    <div className="banner-bottom">
                                        <div className="theme-btn">
                                            <Link onClick={() => handleScroll(CONTACTUS_SECTION_ID)}>
                                            Book Appointment
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div
                                    className="banner-img-area"
                                    data-aos="fade-up"
                                    data-aos-duration="2000"
                                    data-aos-delay="0"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* What's app bot section */}
            <FloatingWhatsApp
                avatar={clinicIcon}
                notification={false}
                accountName="Denvia Dental Clinic"
                phoneNumber={PHONE_NUMBER}
                onSubmit={(e) => {
                    whatsAppBotListener(e.target[0].value);
                }}
            />
        </section>
    );
};

export default Banner;
